import { useContext } from "react";
import { motion } from "framer-motion";
import DecodeText from "./DecodeText";
import HudLabel from "./HudLabel";
import DotsText from "./DotsText";
import { EnteredContext } from "../EnteredContext";
import "./Hero.css";

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
};

// Bio panel grows from a small square into the full box, then a scan line
// sweeps through it twice. Gated on the splash being dismissed.
const bioV = {
  hidden: { scale: 0.06, opacity: 0 },
  show: {
    scale: 1,
    opacity: 1,
    transition: { duration: 0.6, ease: [0.34, 1.2, 0.4, 1] },
  },
};
const scanV = {
  hidden: { top: "-12%", opacity: 0 },
  show: {
    top: ["-12%", "112%"],
    opacity: [0, 1, 0],
    transition: {
      duration: 0.7,
      ease: "easeInOut",
      delay: 0.6, // wait for the box to finish expanding
      repeat: 1, // play the sweep twice
      repeatDelay: 0.15,
    },
  },
};

/** About / hero — the first thing seen after the splash. */
export default function Hero({ profile }) {
  const ready = useContext(EnteredContext);

  return (
    <section id="about" className="section hero">
      <motion.div
        className="hero__inner"
        variants={fadeUp}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.3 }}
      >
        <HudLabel className="hero__eyebrow" text="ABOUT" />
        <DecodeText as="h1" className="hero__name gold-text" text={profile.name} />
        <DotsText as="p" className="hero__tagline" text={profile.tagline} />

        <motion.div
          className="hero__bio hud-panel hud-panel--full"
          variants={bioV}
          initial="hidden"
          animate={ready ? "show" : "hidden"}
        >
          <motion.span className="hero__scan" aria-hidden="true" variants={scanV} />
          <span className="hud-corner-tr" aria-hidden="true" />
          <span className="hud-corner-bl" aria-hidden="true" />
          <p>{profile.bio}</p>
        </motion.div>
      </motion.div>
    </section>
  );
}
